import { render, staticRenderFns } from "./UnknownInput.vue?vue&type=template&id=70bc9dd4&"
import script from "./UnknownInput.vue?vue&type=script&lang=js&"
export * from "./UnknownInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports